<template>
  <div class="radio_question">    
    <div class="qes_txt" :style="{'color':surveyTheme.bodyColor}">
      <i class="qes_num" v-if="surveyTheme.openCode">{{data.showNum}}.</i>
      <div class="qes_name" v-html="data.qesName"></div>
    </div>
    <div class="answers">
      <van-radio-group v-model="showSelected">
        <div class="answers_box" v-for="(a,idx) in data.answers" :key="idx">
          <van-radio :name="a.ansId" :disabled="a.hasAnsCount >= a.ansCount ? true : false" :checked-color="color" @click="selectAnswer(a)">
            <div :style="fontSize == 1 ? {'color':color,'fontSize':'14px'} : {'color':color,'fontSize':'16px'}" class="answer_name" v-html="a.ansName"></div>
          </van-radio>
          <div v-if="a.hasInput && data.showSelected == a.ansId" class="box">
            <input type="text" @blur="selectAnswer(a)" class="text_input" v-model="a.ansInput" placeholder="请输入">
          </div>
        </div>
      </van-radio-group>
    </div>
  </div>
</template>
<script>

 export default {
   components: { 
    
  },
  props: ['data','currentPage','index','color','fontSize'],
  watch: {  
    'data'(){
      console.log('单选题data值变了',this.data);
      if(this.data.showSelected){
        this.showSelected = Number(this.data.showSelected);
        console.log('有值',this.showSelected);
      }else{
        console.log('没有值');
      }
    }
  },
  data(){
    return {
      surveyTheme:{},                         //问卷主题
      showSelected:"",                        //已选答案ID       (前端回显用)
      selectData:{},                          //已选答案相关对象 (提交后台用)
      showTextInput:false,                    //是否显示文本输入
    }
  },
  created(){
    this.data.qesName = this.data.qesName.replaceAll('\n','<br/>');
    console.log(this.data.qesName);
    if(this.data.showSelected){
      this.showSelected = Number(this.data.showSelected);
    }
    this.surveyTheme = JSON.parse(sessionStorage.getItem("surveyTheme"));
    // console.log(this.surveyTheme);
    // console.log('单选题data',this.data);
  },
  methods:{
    selectAnswer(item){
      if(item.hasAnsCount < item.ansCount){
        // console.log(item,this.showSelected);
        this.data.showSelected = this.showSelected;
        let obj = {};
        obj.ansId = item.ansId;
        obj.textInput = item.ansInput;
        obj.hasInput = item.hasInput;
        obj.ansName = item.ansName;
        obj.ansOrder = item.ansOrder;
        obj.qesId = item.qesId;
        obj.surveyId = this.data.surveyId;
        obj.qesType = this.data.qesType;
        obj.otherType = this.data.otherType;
        obj.groId = this.data.groId;
        obj.qesName = this.data.qesName;
        obj.qesNum = this.data.qesNum;
        obj.qesOrder = this.data.qesOrder;
        this.selectData.gIndex = this.currentPage - 1;
        this.selectData.qIndex = this.index;
        this.selectData.submitQesObj = obj;
        // console.log(this.selectData);
        this.$emit("sendAnswer",this.selectData);
      }else{
        this.$toast.fail('该选项已达最大限制数!');
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .radio_question{
    background-color: transparent;
    width: 100%;
    padding: 60px 40px;
    box-sizing: border-box;
    .qes_txt{
      margin-bottom: 40px;
      font-size: 36px;
      color: #333;
      line-height: 56px;
      display: flex;
      .qes_num{
        font-size: 34px;
        // line-height: 65px;
        margin-right: 10px;
      }
      .qes_name{
        font-size: 34px;
        display: inline;
        word-break: break-all;
      }
    }
    .answers{
      &:last-child{
        border-bottom: 1px solid #f6f6f6;
      }
      .answers_box{
        font-size: 32px;
        color: #4d4d4d;
        padding: 32px 0;
        box-sizing: border-box;
        border-top: 1px solid #f6f6f6;
        .answer_name{
          display: flex;
          align-items: center;
        }
        .box{
          margin-top: 20px;
          .text_input{
            width: 90%;
            padding: 15px 20px;
            font-size: 28px;
            border: 1px solid #f3eded;
            border-radius: 6px;
            color: #333;
            background-color: #fbfbfb;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/selectQuestion/radioQuestion.vue